<template>
    <div id="wrapper" :key="valuekey">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">

                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.chart.menu.label.title')}}</h4>
                            </div>
                        </div>
                    </div>

                    <div class="card-deck">

                        <div class="card"> <!--Associados-->
                             <div class="card-body" style="text-align:center;">
                                 <h6 class="card-title">{{$t('string.msg.rel13.label.title')}} </h6>
                                <div class="form-row">
                                    <div class="form-group col-md-12" align="center"> 
                                        <CompaniesPercent    />
                                    </div>
                                </div>
                            </div>    
                        </div>
                        <div class="card"> <!--Veiculos-->
                             <div class="card-body" style="text-align:center;">
                                 <h6 class="card-title">{{$t('string.msg.rel23.label.title')}} </h6>
                                <div class="form-row">
                                   <div class="form-group col-md-12" align="center">
                                        <Truck />
                                    </div>
                                </div>
                            </div>    
                        </div>
                    </div>  

                   <div class="card-deck"> <!--Carretas-->
                        <div class="card">
                            <div class="card-header"></div>
                            <div class="card-body" style="text-align:center;">
                                <h6 class="card-title">{{$t('string.msg.rel27.label.title')}} </h6>
                                <div class="form-row">
                                    <div class="form-group col-md-12" align="center">
                                        <TruckTrailers />
                                    </div>
                                 </div>
                            </div>
                        </div>
                        <div class="card"> <!--Caminhoneiros-->
                            <div class="card-header"></div>
                             <div class="card-body" style="text-align:center;">
                                 <h6 class="card-title">{{$t('string.msg.rel12.label.title')}} </h6>
                                <div class="form-row">
                                   <div class="form-group col-md-12" align="center">
                                        <TruckDrivers />
                                    </div>
                                </div>
                            </div>    
                        </div>
                    </div>

                    <div class="card-deck">

                        <div class="card"> <!--Alerta de Pânico-->
                            <div class="card-header"></div>
                             <div class="card-body" style="text-align:center;">
                                 <h6 class="card-title">{{$t('string.msg.rel15.label.title')}} </h6>
                                <div class="form-row">
                                        <div class="form-group col-md-12" align="center">
                                            <Alerts />
                                        </div>
                                    </div>
                            </div>
                        </div>
                        <div class="card"> <!--Pedidos-->
                            <div class="card-header"></div>
                             <div class="card-body" style="text-align:center;">
                                 <h6 class="card-title">{{$t('string.msg.rel28.label.title')}} </h6>
                                <div class="form-row">
                                   <div class="form-group col-md-12" align="center">
                                        <Orders />
                                    </div>
                                </div>
                            </div>    
                        </div>
                    </div>

                    <div class="card-deck">

                        <div class="card"> <!--Pedidos por mês-->
                            <div class="card-header"></div>
                             <div class="card-body" style="text-align:center;">
                                 <h6 class="card-title">{{$t('string.msg.rel29.label.title')}} </h6>
                                <div class="form-row">
                                        <div class="form-group col-md-12" align="center">
                                            <OrderHolder />
                                        </div>
                                    </div>
                            </div>
                        </div>
                        <div class="card"> <!--Pedidos por mês / Tipos-->
                            <div class="card-header"></div>
                             <div class="card-body" style="text-align:center;">
                                 <h6 class="card-title">{{$t('string.msg.rel30.label.title')}} </h6>
                                <div class="form-row">
                                   <div class="form-group col-md-12" align="center">
                                        <OrderHolderFilter />
                                    </div>
                                </div>
                            </div>    
                        </div>
                    </div>

                     <div class="card-deck">

                        <div class="card"> 
                            <div class="card-header"></div>
                             <div class="card-body" style="text-align:center;">
                                 <h6 class="card-title">{{$t('string.msg.rel33.label.title')}} </h6>
                                <div class="form-row">
                                        <div class="form-group col-md-12" align="center">
                                         <MostTruck />   
                                        </div>
                                    </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header"></div>
                             <div class="card-body" style="text-align:center;">
                                 <h6 class="card-title">{{$t('string.msg.rel32.label.title')}} </h6>
                                <div class="form-row">
                                   <div class="form-group col-md-12" align="center">
                                        <MostTruckTrailer />
                                    </div>
                                </div>
                            </div>    
                        </div>
                    </div>

                    <div class="card-deck">

                        <div class="card"> 
                            <div class="card-header"></div>
                             <div class="card-body" style="text-align:center;">
                                 <h6 class="card-title">{{$t('string.msg.rel34.label.title')}} </h6>
                                <div class="form-row">
                                        <div class="form-group col-md-12" align="center">
                                         <ListManufacture />   
                                        </div>
                                    </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header"></div>
                             <div class="card-body" style="text-align:center;">
                                 <h6 class="card-title">{{$t('string.msg.rel37.label.title')}} </h6>
                                <div class="form-row">
                                   <div class="form-group col-md-12" align="center">
                                        <ListFamily />
                                    </div>
                                </div>
                            </div>    
                        </div>
                    </div>
                     <div class="card-deck">
                          <div class="card">
                            <div class="card-header"></div>
                             <div class="card-body" style="text-align:center;">
                                 <h6 class="card-title">{{$t('string.msg.rel35.label.title')}} </h6>
                                <div class="form-row">
                                   <div class="form-group col-md-12" align="center">
                                        <ListService/>
                                    </div>
                                </div>
                            </div>    
                        </div>

                        <div class="card"> 
                            <div class="card-header"></div>
                            <div class="card-body" style="text-align:center;">
                                 <h6 class="card-title">{{$t('string.msg.rel36.label.title')}} </h6>
                                <div class="form-row">
                                    <div class="form-group col-md-12" align="center">
                                         <ListCertifie />   
                                    </div>
                                </div>
                            </div>
                         </div>
                    

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import Controller from './CrtChart';
import TruckDrivers from './TruckDriver/TruckDriver.vue';
import Alerts from './Alert/Alert.vue';
import Orders from './Orders/Orders.vue';
import Truck from './Truck/Truck.vue';
import TruckTrailers from './TruckTrailer/TruckTrailer.vue';
import CompaniesPercent from './Companies/TotalPercent.vue';
import OrderHolder from './OrderHolder/OrderHolder.vue';
import OrderHolderFilter from './OrderHolder/OrderHolderFilter.vue';
import MostTruckTrailer from './MostTruckTrailer/MostTruckTrailer.vue';
import MostTruck from './MostTruck/MostTruck.vue';
import ListManufacture from './Manufacturers/ListManufacture.vue';
import ListFamily from './Families/ListFamily.vue';
import ListService from './Services/ListServices.vue';
import ListCertifie from './Certifies/ListCertifies.vue';

export default {
    name: 'Chart',
    components: {
        Alerts,
        Orders,
        Truck,
        TruckDrivers,
        TruckTrailers,
        CompaniesPercent,
        OrderHolder,
        OrderHolderFilter,
        MostTruckTrailer,
        MostTruck,
        ListManufacture,
        ListFamily,
        ListService,
        ListCertifie
    },
    
     data() {
      return {
        totalUsersNumber: 0,
        truckDriverNumber: 0,
        companyNumber: 0,
        partsSuplierNumber: 0,
        certifiersNumbers: 0,
        serviceProviderNumber: 0,
        fleetDriversNumber: 0,
        truckDriverNotApprove: 0,   
        totalOrdersNumber: 0,
        totalTruckTrailersNumber: 0,
        totalOrdersClosed: 0,
        totalOrdersWaiting: 0,
        totalOrdersOpened: 0,
        contextChart: null,
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        errors: [],
      }
     },
    
    methods: Controller.methods,

    created() {
        Controller.init(this);
           
    },
    mounted() {
            }
}
    </script>
